import type { MembershipRole, MembershipStatus } from 'src/types';
import { baseFetch } from 'src/utils';

export const updateUserRoleAPI = async (
  id: string,
  email: string,
  role: MembershipRole,
  status: MembershipStatus,
) => {
  const res = await baseFetch(`/api/org/users/role`, {
    method: 'PUT',
    body: JSON.stringify({ id, email, role, status }),
  });

  if (!res.ok) {
    throw new Error('Failed to update user role');
  }

  return true;
};
